import React, { useEffect, useId, useRef } from 'react';
import styled from 'styled-components';
import { Builder_, FormGroup, FormInput, FormLabel, Grey_Link, ValidatorError, device } from 'monica-alexandria';
import { useTranslation } from 'react-i18next';

const Fields = styled.div`
  display: grid;
  gap: 1rem;

  .field-row {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 2fr) auto;
    align-items: center;
    gap: 1rem;
  }

  @media ${device.sm} {
    .field-row { grid-template-columns: minmax(0, 1fr) auto; }
    .field-name { grid-column: 1 / -1; }
  }
`;

export default function LeadCustomFields({ fields, onChange, error = '', disabled = false }) {
  const { t } = useTranslation();
  const prefix = useId();
  const nameInputs = useRef([]);
  const valueInputs = useRef([]);
  const focusNewField = useRef(false);
  useEffect(() => {
    if (focusNewField.current) {
      nameInputs.current[fields.length - 1]?.focus();
      focusNewField.current = false;
    }
  }, [fields.length]);
  const update = (index, changes) => {
    if (!disabled) onChange(fields.map((field, i) => i === index ? { ...field, ...changes } : field));
  };
  return <Builder_ last><Fields>
    {fields.map((field, index) => {
      const id = `${prefix}-extra-${index}`;
      return <div className="field-row" key={id}>
        <FormGroup className="field-name">
          <FormInput id={id} placeholder={t('Field name')} value={field.key} maxLength={80} disabled={disabled}
            ref={input => { nameInputs.current[index] = input; }}
            onKeyDown={event => { if (event.key === 'Enter') { event.preventDefault();valueInputs.current[index]?.focus(); } }}
            onChange={event => update(index, { key: event.target.value })} />
          <FormLabel htmlFor={id}>{t('Field name')} {index + 1}</FormLabel>
        </FormGroup>
        <FormGroup>
          <FormInput id={`${id}-value`} placeholder={t('Field value')} value={field.value ?? ''} disabled={disabled}
            ref={input => { valueInputs.current[index] = input; }}
            onChange={event => update(index, { value: event.target.value })} />
          <FormLabel htmlFor={`${id}-value`}>{t('Field value')} {index + 1}</FormLabel>
        </FormGroup>
        <Grey_Link text={t('Remove field')} size="small" noPadding disabled={disabled} onClick={event => {
          event?.preventDefault();if (!disabled) onChange(fields.filter((_, i) => i !== index));
        }} />
      </div>;
    })}
    {error ? <ValidatorError role="alert">{error}</ValidatorError> : null}
    {fields.length < 20 ? <Grey_Link text={t('Add field')} iconLeft="Add" size="small" noPadding disabled={disabled} onClick={event => {
      event?.preventDefault();if (!disabled) { focusNewField.current = true;onChange([...fields, { key: '', value: '' }]); }
    }} /> : null}
  </Fields></Builder_>;
}
